// Minimal REST wrapper for catalog / projects / admin / sync routes.
// Live-match mutations go through NodeCG messages, not this client.

export type ApiError = { error: string; [k: string]: unknown };

async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(path, {
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      ...(init?.headers ?? {}),
    },
    ...init,
  });
  const body = (await res.json().catch(() => null)) as T | ApiError | null;
  if (!res.ok) {
    const err = (body as ApiError | null) ?? { error: `http_${res.status}` };
    throw Object.assign(new Error(err.error), { status: res.status, body: err });
  }
  return body as T;
}

export const api = {
  get<T>(path: string) {
    return request<T>(path);
  },
  post<T>(path: string, body?: unknown) {
    const init: RequestInit = { method: "POST" };
    if (body !== undefined) init.body = JSON.stringify(body);
    return request<T>(path, init);
  },
  put<T>(path: string, body?: unknown) {
    const init: RequestInit = { method: "PUT" };
    if (body !== undefined) init.body = JSON.stringify(body);
    return request<T>(path, init);
  },
  patch<T>(path: string, body?: unknown) {
    const init: RequestInit = { method: "PATCH" };
    if (body !== undefined) init.body = JSON.stringify(body);
    return request<T>(path, init);
  },
  delete<T>(path: string) {
    return request<T>(path, { method: "DELETE" });
  },
};
